module.exports = __webpack_public_path__ + "static/media/2017_conf_Product_Culture_in_a_Growing_Organisation.78ed98df.png";